import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=307ce0b0"
import script from "./privacyPolicy.vue?vue&type=script&lang=ts"
export * from "./privacyPolicy.vue?vue&type=script&lang=ts"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=307ce0b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports